// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ReactDocxArchive_errorText__2w180","pendingMessage":"ReactDocxArchive_pendingMessage__3NN9P","buttonWrapper":"ReactDocxArchive_buttonWrapper__33L7X"};